import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import { Redirect } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Spin from 'components/Spin';
import Button from 'components/Button';
import toast from 'utils/toast';
import { postUpsells } from 'services/account.service';
import useOrderSummary from '../hooks/useOrderSummary';
import cart from '../cart';
import { Card, Row } from '../styled';

export default ({ history }) => {
  if (global.IS_SERVER) return null;
  const productId = cart.get('product_id');
  const accountHash = cart.get('account_hash');

  if (!productId || !accountHash) {
    return <Redirect to="/404" />;
  }

  const {
    loading,
    plan,
    offers,
    immediate,
    immediateTotal,
    yearly,
    yearlyTotal,
    monthly,
    monthlyTotal,
  } = useOrderSummary(productId);

  const onComplete = () => {
    // TODO complete order
    if (offers.length) {
      return postUpsells(
        accountHash,
        offers.map((i) => i.key),
      ).then(
        () => {
          history.push('/checkout/complete');
        },
        (e) => toast.error(e.message),
      );
    } else {
      history.push('/checkout/complete');
    }
  };

  if (loading) return <Spin spinning />;

  return (
    <Fragment>
      <Helmet>
        <title>Text In Church - Help Your Church Thrive</title>
      </Helmet>
      <Box className="logo" textAlign="center" pb={4}>
        <a href="/">
          <img src={`/assets/svg/tic-logo-full.svg`} alt="logo" />
        </a>
      </Box>
      <Card sx={{ maxWidth: 760, p: 4, mx: 'auto' }}>
        <Typography variant="h1" align="center" sx={{ mb: 4 }}>
          Order Summary
        </Typography>
        <div>
          <Row>
            <strong>Your Subscription</strong>
          </Row>
          <Row>
            <span>{plan.name}</span>
            <strong>
              ${plan.price} per {plan.freq}
            </strong>
          </Row>
          <Row>
            <strong>Your Add-ons</strong>
          </Row>
          {immediate.map((o) => (
            <Row>
              <span>{o.offer_statement_title}</span>{' '}
              <strong>${o.offer_cost} today</strong>
            </Row>
          ))}
          {monthly.map((o) => (
            <Row>
              <span>{o.product_name}</span>{' '}
              <strong>${Number(o.product_amount)} per month</strong>
            </Row>
          ))}
          {yearly.map((o) => (
            <Row>
              <span>{o.product_name}</span>{' '}
              <strong>${Number(o.product_amount)} per year</strong>
            </Row>
          ))}
          <Box p="10px">
            <span>
              <strong>Total:</strong>
            </span>{' '}
            <span>
              {immediateTotal ? `$${immediateTotal} today` : ''}
              {immediateTotal && (monthlyTotal || yearlyTotal)
                ? ' and then '
                : ''}
              {monthlyTotal ? `$${monthlyTotal} per month ` : ''}
              {yearlyTotal ? `$${yearlyTotal} per year ` : ''}
              {plan.trialDuration
                ? `(after your ${plan.trialDuration}-day trial)`
                : ''}
            </span>
          </Box>
        </div>
        <Box mt={6} textAlign="center" id="checkoutOffer">
          <Button onClick={onComplete} size="large" sx={{ px: 4}}>
            Get Started
          </Button>
        </Box>
      </Card>
    </Fragment>
  );
};
